import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Reason } from '@/types/reason'

export function getReasons(): Promise<AxiosResponse<Reason[]>> {
  return instance.get(`/reason`)
}
